<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container fluid>

    <v-row dense no-gutters justify="center">
        <v-col cols="8">
            <label>{{ comname }}</label>
        </v-col>
        <v-col cols="3">
            <v-btn class="search_btn" elevation="0" :disabled="disabled" :color="selectcolor" @click="showpopup_com">{{$t('ccolorpicker_label1')}}</v-btn>
        </v-col>
    </v-row>   
    <v-row>
      <v-dialog style="z-index: 9999;" persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" max-width="420px">
        <v-card class="dialog_round pa-10">

          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t('ccolorpicker_label2')}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close_com"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
              <v-row>
                 <v-color-picker mode="hexa" hide-mode-switch v-model="selectcolor"></v-color-picker>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close_com">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="save_com">{{$t('common_select')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
    export default {

        mounted(){
          this.selectcolor = "#"+this.colorvalue;
        },

        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
            comname: String,
            colorvalue: String,
            cbname:{type:String, default: "dev..."},
            disabled: {type:Boolean, default: false}
        },

        data: ()=> ({
            dialog_com : false,
            selectcolor: "",
        }),

        methods: {

            updatecolor(newcl){
              this.selectcolor = "#"+newcl;
            },

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
            },

            //추가 저장
            save_com () {
              this.$emit('callback', this.selectcolor)
              //콜백 호출 후 닫아야함.
              this.dialog_com = false
            },      

            showpopup_com(){
                this.dialog_com = true;
            },


        }

    }
</script>

<style scoped>

  label {
    display: table-cell;
    vertical-align: middle;
    height: 40px;
  }

</style>